// Input validation utility functions

/**
 * Only allow numbers (0-9) and navigation keys
 * @param {KeyboardEvent} e - The keyboard event
 */
export const handleNumbersOnly = (e) => {
  const allowedKeys = [
    "Backspace",
    "Delete",
    "ArrowLeft",
    "ArrowRight",
    "ArrowUp",
    "ArrowDown",
    "Tab",
    "Enter",
  ];
  const isNumber = e.key >= "0" && e.key <= "9";

  if (!isNumber && !allowedKeys.includes(e.key)) {
    e.preventDefault();
  }
};

/**
 * Only allow text (no numbers 0-9)
 * @param {KeyboardEvent} e - The keyboard event
 */
export const handleTextOnly = (e) => {
  // Prevent numbers 0-9
  if (e.key >= "0" && e.key <= "9") {
    e.preventDefault();
  }
};

/**
 * Only allow letters, spaces and navigation keys (strict text validation)
 * @param {KeyboardEvent} e - The keyboard event
 */
export const handleLettersAndSpacesOnly = (e) => {
  const allowedKeys = [
    "Backspace",
    "Delete",
    "ArrowLeft",
    "ArrowRight",
    "ArrowUp",
    "ArrowDown",
    "Tab",
    "Enter",
  ];

  const isLetter = /^[a-zA-Zㄱ-ㅎㅏ-ㅣ가-힣]$/.test(e.key);
  const isSpace = e.key === " ";

  if (!isLetter && !isSpace && !allowedKeys.includes(e.key)) {
    e.preventDefault();
  }
};

/**
 * Handle paste events to filter numbers only
 * @param {ClipboardEvent} e - The paste event
 */
export const handleNumbersOnlyPaste = (e) => {
  e.preventDefault();
  const paste = (e.clipboardData || window.clipboardData).getData("text");
  const numbersOnly = paste.replace(/[^0-9]/g, "");
  e.target.value = numbersOnly;
};

/**
 * Handle paste events to filter text only (remove numbers)
 * @param {ClipboardEvent} e - The paste event
 */
export const handleTextOnlyPaste = (e) => {
  e.preventDefault();
  const paste = (e.clipboardData || window.clipboardData).getData("text");
  const textOnly = paste.replace(/[0-9]/g, "");
  e.target.value = textOnly;
};
